import { render, staticRenderFns } from "./ChangeSignature.vue?vue&type=template&id=63997472&scoped=true"
import script from "./ChangeSignature.vue?vue&type=script&lang=js"
export * from "./ChangeSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63997472",
  null
  
)

export default component.exports